import React, { useMemo } from 'react';
import tinycolor from 'tinycolor2';

type RgbDisplayProps = {
  color?: string;
};

function RgbDisplay({ color }: RgbDisplayProps) {
  if (!color) return null;

  const rgb = useMemo(() => tinycolor(color).toRgbString(), [color]);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '135px',
      }}
    >
      <div
        style={{ height: '10px', width: '10px', backgroundColor: color, marginRight: '0.5em' }}
      />
      <span>{rgb}</span>
    </div>
  );
}

export default RgbDisplay;
